function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 104",
  transform: "translate(-279 -3968)"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 92",
  cx: 34.5,
  cy: 33,
  rx: 34.5,
  ry: 33,
  transform: "translate(279 3968)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon feather-repeat",
  fill: "none",
  stroke: "#fdf2f0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 14",
  d: "M321 3985l6 6-6 6"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 15",
  d: "M300 4000v-3a6 6 0 016-6h21"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 16",
  d: "M306 4018l-6-6 6-6"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 17",
  d: "M327 4003v3a6 6 0 01-6 6h-21"
})));
var SvgTrialRuns = function SvgTrialRuns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69 66"
  }, props), _ref);
};
export default SvgTrialRuns;